/**
 * DownloadData slot component.
 */
export const DownloadData = () => null;

DownloadData['displayName'] = 'ChartInteractions.DownloadData';
